/**
 * A timeout will run at this point if `checkCanFocusTrap` in focus trap options hasn't
 * found tabbable nodes for a trap to activate. The timeout will `resolve` the
 * `checkCanFocusTrap` callback's `Promise`
 **/
export const FOCUS_TRAP_TIMEOUT_FALLBACK = 200;
